import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import React from 'react';
import { ClassificationType } from '../../../types';

interface EmbeddingTypeFilterProps {
  value: ClassificationType | 'all';
  onChange: (value: ClassificationType | 'all') => void;
}

export const EmbeddingTypeFilter: React.FC<EmbeddingTypeFilterProps> = ({ value, onChange }) => {
  const handleChange = (event: SelectChangeEvent<ClassificationType | 'all'>) => {
    onChange(event.target.value as ClassificationType | 'all');
  };

  return (
    <FormControl size="small" sx={{ minWidth: 120 }}>
      <InputLabel size="small">Filter</InputLabel>
      <Select value={value} size="small" label="Filter" onChange={handleChange}>
        <MenuItem value="all">All</MenuItem>
        <MenuItem value="product">Product</MenuItem>
        <MenuItem value="carton">Carton</MenuItem>
      </Select>
    </FormControl>
  );
};
